// eslint-disable-next-line @typescript-eslint/no-explicit-any -- type is unknown
export const localeFilesMap: Record<string, Promise<any>> = {
  'en-NL': import('./i18n/en-NL.json'),
  'nl-NL': import('./i18n/nl-NL.json'),
}
